import React from 'react'
import Nav from '../Navigation/Nav'

const ResaleHero = () => {
    return (
        <div className='flex flex-col lg:px-[8%] px-[4%] relative z-[500] text-white'>
            <Nav />
            <div className='w-full flex items-center flex-col gap-5 lg:py-[3%] py-[5%]'>
                <p className='text-4xl font-bold text-blue-400'>Resale Policy</p>
                <div className='flex flex-col lg:w-[80%] w-[98%] lg:gap-10 gap-5 lg:text-xl text-justify'>
                    <p>Our team is currently working on creating a Marketplace for ASIC miners. Our customers will be able to sell through the platform as soon as it is ready. Please contact us if you host miners through Supreme Mining so we can assist you with the resale.</p>
                    <p>Please be aware that Supreme Mining has no responsibility to facilitate or guarantee the successful resale of miners purchased from our site.</p>
                    <p>Because hosting contracts are non-transferable, Supreme Mining reserves the right to cancel any customer’s hosting services if they sell their miners contract. Customers can choose to take custody of their miners after the contract has expired.</p>
                </div>
            </div>
        </div>
    )
}

export default ResaleHero